import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import FeatherIcon from 'feather-icons-react';
import { getPath, removeHyphen } from 'utlis/helpers/Common/Helper';
import { INTEGRATIONTABLE, INTEGRATIONTOP } from '../../Includes/ConstArray';

function IntegrationDetailsContent(props) {
    const [key, setKey] = useState("")

    useEffect(() => {
        setKey(removeHyphen(getPath(window.location)))
    }, []);

    const integrations = INTEGRATIONTABLE.find(e => e.title === key) || {}
    const integrations_ = INTEGRATIONTOP.find(e => e.title === key) || {}


    return (
        <div className="app-card">
            <div className="app-card-content border st-default-rounded-block">
                <div className="integrations-top-content border-bottom ">
                    <div className="app-header-wrapper heading-sm mb-1 pad-25-R">
                        <div className="d-flex align-items-center  pad-12-B">
                            <FeatherIcon
                                icon="bar-chart"
                                size="26"
                                className="icon me-1" />
                            <span className="app-heading text-capitalize">{integrations.title || integrations_.title}</span>
                        </div>
                        <p className="app-integrations-desc">{integrations.desc || integrations_.desc}</p>
                        <ul className="integrations-list">
                            {(Array.isArray(integrations.list) && integrations.list.map((e, index) =>
                                <li key={index}>{e}</li>
                            ))
                                || (Array.isArray(integrations_.list) && integrations_.list.map((e, index) =>
                                    <li key={index}>{e}</li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className="d-flex">
                        image
                    </div>
                </div>
                <div className="pad-20 integrations-bottom-content d-flex justify-content-between">
                    <div className="content-right">
                        <div className="d-flex align-items-center " >
                            <span className="app-heading text-capitalize me-3">{(integrations.title || integrations_.title) + " Integration"}</span>
                            <button
                                type="button"
                                className="st-btn no-min-width st-btn-gray st-btn-sm  min-height-auto d-flex align-items-center justify-content-center me-2">
                                Inactive
                            </button>
                        </div>
                        <p className="app-integrations-desc pad-12-T">
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                        <p className="app-integrations-desc pad-12-T">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.Lorem ipsum dolor sit amet, consetetur sadipscing elitr.</p>
                        <div className="mt-3">
                            {/* <button
                                className="st-btn  st-btn-primary  st-btn-sm d-inline-block no-min-width min-height-auto align-items-center justify-content-center me-2">
                                
                            </button> */}
                            {/* clientid= AB9fcIfOmhJAMlkezYxfjrJzsmJmM8mGdMv8CrLcSXcyqjs0gM*/}
                            <a href={integrations.link || integrations_.link}
                                className="st-btn  st-btn-primary  st-btn-sm d-inline-block no-min-width min-height-auto align-items-center justify-content-center me-2"
                            >Authorize</a>
                        </div>
                    </div>
                    <div className="app-card-content border st-default-rounded-block pad-12">
                        <p className="app-heading-card text-capitalize me-3">About {integrations.title || integrations_.title} Integration</p>
                        <p className="app-desc-card text-capitalize me-3">{integrations.sub_title || integrations_.sub_title}</p>
                        <p className="app-desc-card text-primary text-capitalize me-3 st-fw-600">{integrations.title || integrations_.title} Support Article</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(IntegrationDetailsContent)